import React from 'react';
import {Table, Card, Button, Select, Typography, DatePicker, Tag, Modal, Space, Divider, Input} from "antd";
import {emFCModeReport, emFCModeReportList, visualize} from '../api/api'
import moment from "moment";

export const EMSelect = ({value,onChange})=>{

    const [em, setEm] = React.useState([])

    const load = async ()=>{
        const {data:{rows = []}} = await visualize('em_name')
        setEm(rows.map(({id, full_name})=>({id,full_name})))
    }

    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <Select showSearch optionFilterProp={'children'} placeholder="Select an EM" style={{width: 400}} key={em} onChange={onChange} value={value}>
            {
                em.map(({id,full_name})=><Select.Option key={id} value={id}>{full_name}</Select.Option>)
            }
        </Select>
    </React.Fragment>
}


export const EMFCModeReportView = (props)=>{

    const [em,setEm] = React.useState()
    const [source, setSource] = React.useState([]);
    
    const load = async ()=>{
        if(em) {
            const {data:{rows=[]}} = await emFCModeReportList({id:em})
            setSource(rows)
        }else
            setSource([])
    }

    React.useEffect(()=>{
        load();
    },[em])

    return <React.Fragment>
        <Card
            title={<EMSelect value={em} onChange={e=>setEm(e)}/>}
        >
            <Table
                dataSource={source}
                pagination={false}
                size={`small`}
            >

                <Table.Column dataIndex={'id'} title={'FC Mode Order Report'} render={(value, row, index) => {

                    const { effective_month, em_id } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await emFCModeReport(em_id, effective_month)
                        }}>Download</Button>
                    </Space>;
                }} />
                 <Table.Column dataIndex={'duration'} title={'Duration'} render={(value,row,index)=>{
                    const data = value.split(",").map(o=>{
                        return o.match(/\d{4}-\d{2}-\d{2}/g) || "STARTED"
                    }).join(" - ")
                    return <Typography.Text>{data}</Typography.Text>
                }}/>
             </Table>
        </Card>

    </React.Fragment>
}